import { Fragment } from 'react';

import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';

const MAX_ACTIONS = 3;

/**
 * A full-width row of up to 3 equal-width actions divided by vertical lines.
 * `actions` only describes what to render (key/label/icon/disabled); clicking
 * always reports back to the parent via `onClick(action.key)`.
 */
export const ButtonGroup = ({ actions, onClick, className }) => {
  const visibleActions = actions.slice(0, MAX_ACTIONS);

  return (
    <div className={cn('flex items-stretch w-full', className)}>
      {visibleActions.map((action, index) => (
        <Fragment key={action.key}>
          {index > 0 && <div className="w-px bg-border-primary" aria-hidden="true" />}
          <button
            type="button"
            disabled={action.disabled}
            onClick={() => onClick(action.key)}
            className="flex-1 flex items-center justify-center gap-2 py-6 text-xl font-medium text-text-primary bg-transparent border-0 cursor-pointer hover:bg-surface-secondary transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            {action.icon && <FeatherIcon icon={action.icon} size={18} />}
            {action.label}
          </button>
        </Fragment>
      ))}
    </div>
  );
};
